import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createRipple, onChildrenDrawerCloseIntegraciones, DrawerCarroCompra, DrawerMasInformacion, DrawerFichaClienteTaller, DrawerFichaClienteSocio } from "../action/actionCreators"
import { getCestaLineasEnAPI, eliminarCestaLineasEnAPI, setCestaLineasEnAPI, vaciarCestaLineasEnAPI, getClienteTallerEnAPI, GetCSVEnAPI, ObtenerEstadisticasProveedoresRedTalleresEnAPI, ObtenerEstadisticasCentrosTalleresRedEnAPI } from "../action/actionCreatorsRequests"
import { traducirPagina, referenciaActualSelect, convertirMoneda, redondeo, MSGOK, convertirAMesACodigo, obtenerFechaLocalObjeto, convertirCodigoAMeses, descargarDocPasandoBase64Generico } from '../librerias/funciones'
import { MDBCol, MDBTable, MDBTableHead, MDBTableBody, MDBDropdownMenu, MDBDropdown, MDBDropdownToggle, MDBDropdownItem } from 'mdbreact';


import { Select, Card, Modal, Button, Input, Row, Col, Drawer } from 'antd';
import {
    BarChartOutlined,
    EyeOutlined,
    FileExcelFilled,
    FileExcelOutlined,
    TableOutlined
} from '@ant-design/icons';

import store from "../store";
const { Option } = Select;
const FichaDetalleConsumo = ({ props, configApp }) => {
    const [hayRegristros, setHayRegristros] = React.useState(false);
    const [estadisticaCentros, setEstadisticaCentros] = React.useState([]);




    const ObtenerEstadisticasCentrosTalleresRed = (TOP, ID_RED, TIPO_RED) => {
        setEstadisticaCentros([])

        ObtenerEstadisticasCentrosTalleresRedEnAPI(TOP, ID_RED, TIPO_RED).then((registros) => {
            if (registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setEstadisticaCentros(registros.REGISTROS)
            } else {
                setEstadisticaCentros(null)
            }
        })
    }

    const ObtenerEstadisticasProveedoresRedTalleres = (TOP, ID_RED, TIPO_RED) => {
        setEstadisticaCentros([])

        ObtenerEstadisticasProveedoresRedTalleresEnAPI(TOP, ID_RED, TIPO_RED).then((registros) => {
            if (registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
                setEstadisticaCentros(registros.REGISTROS)


            } else {
                setEstadisticaCentros(null)
            }
        })
    }

    const EstadisticasGenericaCSV = (registros) => {
        GetCSVEnAPI(registros).then((doc) => {
            if (doc !== undefined) {
                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }
            }
        })
    }


    if (!hayRegristros && props.ESTADO_FICHA) {
        setHayRegristros(true);

        if (props.TIPO === "centro") {
            ObtenerEstadisticasCentrosTalleresRed(false, props.RED.ID, props.RED.TIPO)

        } else {
            ObtenerEstadisticasProveedoresRedTalleres(false, props.RED.ID, props.RED.TIPO)

        }

    } else {
        if (!props.ESTADO_FICHA && hayRegristros) {

            setHayRegristros(false)
            setEstadisticaCentros([])
        }
    }


    return (
        <div>
            <Drawer
                width={850}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ESTADO_FICHA}
                closable={false}
                placement={"right"}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>

                <div className="flex-container-Grow-Tercero" >
                    <div style={{ textAlign: 'inherit' }}>
                        <button className="backgrounNegroClaro soloColorBlanco" aria-label="Close" style={{ border: 'none', width: '61px', height: '61px', padding: '0px', margin: '0px', borderRadius: 'unset' }}
                            onClick={(e) => {
                                props.CERRAR_FICHA(false)
                            }}>
                            <i aria-label="icon: close" className="anticon anticon-close">
                                <svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true" style={{ fontSize: '16px' }} ><path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"></path>
                                </svg>
                            </i>
                        </button>
                    </div>


                    <div style={{ textAlign: 'left', color: '#fff', verticalAlign: 'middle', paddingLeft: '10px', fontSize: '16px' }}>
                        {props.title}
                    </div>

                    <div style={{ flexGrow: '1', textAlign: 'end', color: '#fff', verticalAlign: 'middle', paddingRight: '10px', fontSize: '16px' }}>
                        <button style={{ width: '200px', height: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: '#4285f4', color: '#fff' }} onClick={(e) => { EstadisticasGenericaCSV(estadisticaCentros) }}><FileExcelOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{traducirPagina("Descargar_csv")} </span>  </button>
                    </div>
                </div>


                <div className="p-3">
                    {estadisticaCentros !== null || estadisticaCentros === undefined ?
                        estadisticaCentros.length > 0 ?
                            <div style={{ height: (configApp.height - 180).toString() + "px", overflowX: 'hidden', overflowY: 'auto' }}>

                                <table style={{ border: '1px solid #d9d9d9', width: '100%', color: '#000' }} >
                                    <thead>
                                        <tr style={{ backgroundColor: '#e0e0e0' }}>
                                            <th style={{ width: '100px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{"CIF"}  </th>

                                            <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{traducirPagina("Nombre")}  </th>
                                            <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}> {traducirPagina("Consumo")} </th>
                                            <th style={{ width: '180px', border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}> {traducirPagina("Acumulado")} </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {estadisticaCentros.map((registro, i) =>
                                            <tr key={i} style={{ backgroundColor: '#fff' }}>
                                                {props.TIPO === "centro" ?
                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.CIF_TALLER}</td>
                                                    :
                                                    <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{registro.CIF_SOCIO}</td>
                                                }
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{props.TIPO === "centro" ? registro.TALLER : registro.SOCIO}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }} >{convertirMoneda(registro.IMPORTE, "€")}</td>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'right' }}>{convertirMoneda(registro.ACUMULADO, "€")}</td>

                                            </tr>
                                        )}

                                    </tbody>
                                </table>

                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                        :
                        null
                    }
                </div>
            </Drawer>
        </div>
    )
}



FichaDetalleConsumo.propTypes = {
    title: PropTypes.string,
    ESTADO_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    TIPO: PropTypes.string,
    RED: PropTypes.object
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        openDrawerFichaClienteSocio: state.estadoDrawer.openDrawerFichaClienteSocio,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado
    };
}

export default connect(mapStateToProps)(FichaDetalleConsumo);